var __rest =
  (this && this.__rest) ||
  function (e, t) {
    var n = {};
    for (r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols)
      for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
        t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
    return n;
  };
let bbb_startTime = performance.now(),
  BBB_IS_DEV = !1;
if (window.BBB_HAS_RUN) console.log("Bloom: Product Feature Bullets has already run");
else if (window.bbb_filterObject) {
  window.BBB_HAS_RUN = !0;
  let e = [
      "https://heybloom.app/fontawesome%2Fv2%2Fcss%2Ffontawesome.css",
      "https://heybloom.app/fontawesome%2Fv2%2Fcss%2Flight.css",
      "https://heybloom.app/fontawesome%2Fv2%2Fcss%2Fregular.css",
      "https://heybloom.app/fontawesome%2Fv2%2Fcss%2Fsolid.css",
      "https://heybloom.app/fontawesome%2Fv2%2Fcss%2Fbrands.css"
    ],
    n = document.createDocumentFragment();
  e.forEach((e) => {
    var t = document.createElement("link");
    (t.type = "text/css"), (t.rel = "stylesheet"), (t.href = e), n.appendChild(t);
  }),
    document.head.appendChild(n),
    (async () => {
      var e,
        t,
        n,
        a,
        r,
        o,
        s = await bbb_fetchData();
      s.loadLimitExceeded
        ? console.error("Load limit exceeded.")
        : s.error
        ? console.error("Error fetching data:", s.error)
        : (({ HTML: s = {}, CUSTOM_CSS: e = "", GLOBAL_CSS: t = "", setsPluginsClientData: n } = s),
          ({ variants: a, currently_selected_variant: r } = o = bbb_furtherObject),
          (o = __rest(o, ["variants", "currently_selected_variant"])),
          await bbb_injectBullets(
            bbb_insertDefaultVariables(s, Object.assign(Object.assign(Object.assign({}, bbb_filterObject), o), a[r])),
            t,
            e
          ),
          bbb_addPlugins(document, n),
          bbb_addEventListeners(document),
          bbb_addVariantListener(s, Object.assign(Object.assign({}, bbb_filterObject), o), a));
    })();
} else console.warn("Bloom: Product Feature Bullets filter object not found");
async function bbb_fetchData() {
  var e = BBB_IS_DEV
    ? "http://127.0.0.1:5001/better-product-description/us-central1/getHTMLStorefrontV2?"
    : "https://us-central1-better-product-description.cloudfunctions.net/getHTMLStorefrontV2?";
  let n = new URLSearchParams();
  return (
    Object.entries(bbb_filterObject).forEach(([e, t]) => {
      n.append(e, String(t));
    }),
    (await fetch(e + n.toString())).json()
  );
}
function bbb_injectCSS(e) {
  var t = document.createElement("style");
  (t.innerHTML = e), (document.head || document.getElementsByTagName("head")[0]).appendChild(t);
}
function bbb_sortById(e, t) {
  return parseInt(e) - parseInt(t);
}
function bbb_injectHTML(r) {
  ["all", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach((a) => {
    var t = document.getElementsByClassName("better-bullets-container-" + a) || [];
    for (let e = 0; e < t.length; e++) {
      let n = t[e];
      Object.keys(r)
        .sort(bbb_sortById)
        .forEach((e, t) => {
          ("all" !== a && a !== t) ||
            ((t = document.createElement("div")).classList.add("b_b_b_" + e),
            (t.style.width = "100%"),
            (t.innerHTML = r[e]),
            n.appendChild(t));
        });
    }
  }),
    bbb_logInjectionTime(performance.now() - bbb_startTime);
}
async function bbb_injectBullets(e, t, n) {
  bbb_injectHTML(e), t && bbb_injectCSS(t), n && bbb_injectCSS(n);
}
function bbb_addVariantListener(a, r, o) {
  function e(n) {
    return function (...e) {
      var e = n.apply(this, e),
        t = bbb_getQueryParamValue(window.location.search, "variant");
      return (
        null !== t &&
          ((r = Object.assign(Object.assign({}, r), o[t])), bbb_updateTextContent(bbb_insertDefaultVariables(a, r))),
        e
      );
    };
  }
  (history.pushState = e(history.pushState)), (history.replaceState = e(history.replaceState));
}
function bbb_getQueryParamValue(e, t) {
  return new URLSearchParams(e).get(t);
}
function bbb_insertDefaultVariables(e, n) {
  let t = Object.assign({}, e);
  var a;
  n.compare_at_price &&
    ((a = ((e = Number(n.compare_at_price.replace(",", "."))) - Number(n.price.replace(",", "."))).toFixed(2)),
    (n.price_difference = a),
    (n.price_discount = ((Number(a) / e) * 100).toFixed(0)));
  let r = /\{\{(\w+?)\}\}/g;
  return (
    Object.keys(t).forEach((e) => {
      t[e] = t[e].replace(r, (e, t) => (n[t] ? String(n[t]) : e));
    }),
    t
  );
}
function bbb_updateTextContent(o) {
  Object.keys(o).forEach((t) => {
    var n = document.getElementsByClassName("b_b_b_" + t);
    for (let e = 0; e < n.length; e++) {
      var a = n[e].firstChild,
        r = new DOMParser(),
        r =
          null == (r = null == (r = null == r ? void 0 : r.parseFromString(o[t], "text/html")) ? void 0 : r.body)
            ? void 0
            : r.firstChild;
      a && r && bbb_compareAndReplaceNodes(a, r);
    }
  });
}
function bbb_compareAndReplaceNodes(e, t) {
  if (3 === e.nodeType && 3 === t.nodeType && e.textContent !== t.textContent) e.textContent = t.textContent;
  else if (1 === e.nodeType && 1 === t.nodeType) {
    var n = Array.from(e.childNodes),
      a = Array.from(t.childNodes);
    for (let e = 0; e < Math.min(n.length, a.length); e++) bbb_compareAndReplaceNodes(n[e], a[e]);
  }
}
function bbb_logInjectionTime(e) {
  console.log(`%cBloom took ${e.toFixed(0)} milliseconds to inject the Bullets`, "color: green");
}
function bbb_addEventListeners(e) {
  e = e instanceof Document ? e.body : e.current;
  if (e) {
    var t = e.getElementsByClassName("b-b-b-dropdown-button"),
      a =
        (Array.from(t).forEach((e) => {
          var t,
            n = e.cloneNode(!0);
          null != (t = e.parentNode) && t.replaceChild(n, e);
        }),
        e.getElementsByClassName("b-b-b-dropdown-button")),
      r = e.getElementsByClassName("b-b-b-dropdown-icon"),
      o = e.getElementsByClassName("b-b-b-dropdown-content");
    for (let e = 0; e < a.length; e++) {
      var s = a[e];
      let t = r[e],
        n = o[e];
      s && t && n
        ? s.addEventListener("click", function (e) {
            e.stopPropagation();
            e = n.scrollHeight;
            n.style.setProperty("--max-height", e + "px"),
              n.style.setProperty("--top-margin", "7px"),
              n.style.setProperty("--bottom-margin", "10px"),
              t.classList.toggle("b-b-b-rotate-caret-up"),
              n.classList.toggle("b-b-b-no-height"),
              n.classList.toggle("b-b-b-full-height");
          })
        : console.warn("Missing elements for collapse button " + e);
    }
  } else console.warn("No base element found for adding event listeners");
}
function bbb_addPlugins(e, t) {
  t &&
    Object.keys(t).length &&
    (e instanceof Document ? e : e.current) &&
    Object.keys(t).forEach((n) => {
      let a = t[n];
      Object.keys(a).forEach((e) => {
        var t = `b_b_b_plugin_${e}_` + n;
        switch (e) {
          case "countdown":
            bbb_setupCountdownTimer(Object.assign(Object.assign({}, a[e]), { className: t }));
            break;
          case "deliveryDate":
            bbb_setupDeliveryDate(Object.assign(Object.assign({}, a[e]), { className: t }));
        }
      });
    });
}
function bbb_setupCountdownTimer({
  countdownType: n = "targetDate",
  targetDate: a,
  targetTime: r,
  countdownFormat: e,
  countdownTemplate: t,
  hideLeadingZeros: o,
  className: s
}) {
  let b = "custom" === t ? e : t;
  (e = window.bbbCountdownIntervals || {}),
    s && e[s] && (clearInterval(e[s]), delete e[s]),
    window.bbbCountdownIntervals || (window.bbbCountdownIntervals = {}),
    (t = () => {
      var e,
        t = document.getElementsByClassName(s);
      0 === t.length
        ? s &&
          window.bbbCountdownIntervals[s] &&
          (clearInterval(window.bbbCountdownIntervals[s]), delete window.bbbCountdownIntervals[s])
        : "repeatsForever" === n
        ? bbb_updateRepeatingCountdown(r, b, Array.from(t), o)
        : (e = bbb_getActualTargetDate(a, r)) instanceof Date &&
          !isNaN(e) &&
          bbb_updateCountdown(e, b, Array.from(t), o);
    });
  s && (window.bbbCountdownIntervals[s] = setInterval(t, 1e3)), t();
}
function bbb_getActualTargetDate(e, t) {
  var [e, n, a] = e.split("/").map(Number);
  return new Date(a, e - 1, n, ...t.split(":").map(Number));
}
function bbb_updateCountdown(e, n, t, a = !1) {
  var r = new Date();
  let o = e.getTime() - r.getTime();
  t.forEach((e) => {
    var t;
    document.contains(e) &&
      ((t = e.closest(".b-b-b-bullet-row")),
      o <= 0
        ? (t && (t.style.display = "none"), (e.innerHTML = ""))
        : (t && (t.style.display = ""),
          (t = bbb_formatCountdown(bbb_calculateTimeComponents(o, n), n, a)),
          (e.innerHTML = t)));
  });
}
function bbb_updateRepeatingCountdown(e, t, n, a = !1) {
  var r = new Date(),
    [e, o] = e.split(":").map(Number),
    e = new Date(r.getFullYear(), r.getMonth(), r.getDate(), e, o),
    o = (e < r && e.setDate(e.getDate() + 1), e.getTime() - r.getTime());
  let s = bbb_formatCountdown(bbb_calculateTimeComponents(o, t), t, a);
  n.forEach((e) => {
    document.contains(e) && (e.innerHTML = s);
  });
}
function bbb_formatCountdown(e, t, n) {
  let a = {
    weeks: bbb_formatNumber(e.weeks, n),
    days: bbb_formatNumber(e.days, n),
    hours: bbb_formatNumber(e.hours, n),
    minutes: bbb_formatNumber(e.minutes, n),
    seconds: bbb_formatNumber(e.seconds, n)
  };
  return t.replace(/\{\{(weeks|days|hours|minutes|seconds)\}\}/g, (e) => {
    var t = e.replace(/[{}]/g, "");
    return t in a ? a[t] : e;
  });
}
function bbb_formatNumber(e, t) {
  return t ? e.toString() : e.toString().padStart(2, "0");
}
function bbb_calculateTimeComponents(e, t) {
  let n = 0,
    a = 0,
    r = 0,
    o = 0,
    s = Math.floor(e / 1e3);
  return (
    t.includes("{{weeks}}") && ((n = Math.floor(s / 604800)), (s -= 7 * n * 24 * 60 * 60)),
    t.includes("{{days}}") && ((a = Math.floor(s / 86400)), (s -= 24 * a * 60 * 60)),
    t.includes("{{hours}}") && ((r = Math.floor(s / 3600)), (s -= 60 * r * 60)),
    t.includes("{{minutes}}") && ((o = Math.floor(s / 60)), (s -= 60 * o)),
    { weeks: n, days: a, hours: r, minutes: o, seconds: s }
  );
}
function bbb_setupDeliveryDate(e) {
  let t = bbb_formatDateString(bbb_calculateDeliveryDate(e), e);
  e = document.getElementsByClassName(e.className);
  Array.from(e).forEach((e) => {
    e.innerHTML = t;
  });
}
function bbb_calculateDeliveryDate(e) {
  var t = parseInt(e.orderProcessingTime),
    n = parseInt(e.shippingTime),
    a = new Date(),
    [r, o] = e.cutOffTime.split(":").map(Number),
    s = new Date(a),
    b = (s.setHours(r, o, 0, 0), a.getTime() >= s.getTime() && a.setDate(a.getDate() + 1), new Date(a));
  let i = t;
  for (; 0 < i; ) {
    var l = bbb_isWorkingDay(b, e.workingDays),
      c = bbb_isHoliday(b, e);
    l && !c && i--, b.setDate(b.getDate() + 1);
  }
  b.setDate(b.getDate() - 1);
  var r = new Date(b),
    u = (r.setDate(r.getDate() + 1), new Date(r));
  let d = n;
  for (; 0 < d; ) {
    var m = bbb_isWorkingDay(u, e.workingDaysShipping),
      g = bbb_isHoliday(u, e);
    m && !g && d--, u.setDate(u.getDate() + 1);
  }
  return u.setDate(u.getDate() - 1), u;
}
function bbb_isWorkingDay(t, e) {
  if (!e) {
    let e = t.getDay();
    return 1 <= e && e <= 5;
  }
  let n = t.getDay();
  return e[["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"][n]];
}
function bbb_isHoliday(e, t) {
  var n = bbb_formatDate(e, "MM/DD"),
    e = bbb_formatDate(e, "MM/DD/YYYY");
  return (
    t.commonHolidays.includes(n) ||
    t.customHolidays.includes(n) ||
    t.commonHolidays.includes(e) ||
    t.customHolidays.includes(e)
  );
}
function bbb_formatDate(e, t) {
  var n = e.getDate(),
    a = e.getMonth() + 1,
    e = e.getFullYear(),
    n = n < 10 ? "0" + n : n.toString(),
    a = a < 10 ? "0" + a : a.toString();
  if ("MM/DD" === t) return a + "/" + n;
  if ("MM/DD/YYYY" === t) return a + `/${n}/` + e;
  throw new Error("Unsupported format: " + t);
}
function bbb_formatDateString(n, a) {
  var e = "custom" !== a.deliveryDateTemplate ? a.deliveryDateTemplate : a.deliveryDateFormat;
  let r = navigator.language || "en-US",
    o = (e) => {
      e = e.toString();
      return a.hideLeadingZeros || 1 < e.length ? e : "0" + e;
    };
  return e.replace(
    /\{\{(week_day|week_day_short|week_day_narrow|date|date_nth|month|month_num|year|year_short|days_left)\}\}/g,
    (e) => {
      switch (e) {
        case "{{week_day}}":
          return n.toLocaleString(r, { weekday: "long" });
        case "{{week_day_short}}":
          return n.toLocaleString(r, { weekday: "short" });
        case "{{week_day_narrow}}":
          return n.toLocaleString(r, { weekday: "narrow" });
        case "{{date}}":
          return o(n.getDate());
        case "{{date_nth}}":
          return bbb_getOrdinalSuffix(n.getDate().toString());
        case "{{month}}":
          return n.toLocaleString(r, { month: "long" });
        case "{{month_num}}":
          return o(n.getMonth() + 1);
        case "{{year}}":
          return n.getFullYear().toString();
        case "{{year_short}}":
          var t = n.getFullYear().toString().substr(-2);
          return a.hideLeadingZeros || 1 < t.length ? t : "0" + t;
        case "{{days_left}}":
          return bbb_calculateDaysLeft(n).toString();
        default:
          return e;
      }
    }
  );
}
function bbb_calculateDaysLeft(e) {
  var t = new Date(),
    e = e.getTime() - t.getTime();
  return Math.ceil(e / 864e5);
}
function bbb_getOrdinalSuffix(e) {
  var t = parseInt(e) % 10,
    n = parseInt(e) % 100;
  return 1 == t && 11 != n ? e + "st" : 2 == t && 12 != n ? e + "nd" : 3 == t && 13 != n ? e + "rd" : e + "th";
}